import React, { useState } from "react";
import { FormControlLabel, Switch, Tooltip } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import {
  CommitteCompanyName,
  CommitteCompanyTitle,
  CompanyActionButton,
  CompanyBox,
} from "./styles";
import { ICompany } from "../../../../../../types/companies";
import { UpdateCompanyBody } from "../CompaniesList";

interface ICompaniesListProps {
  company: ICompany;
  handleUpdateCompany: (company: ICompany) => void;
  handleUpdateCompanyStatus: (
    id: string,
    data: UpdateCompanyBody
  ) => Promise<void>;
}

const CompaniesListItem: React.FC<ICompaniesListProps> = ({
  company,
  handleUpdateCompany,
  handleUpdateCompanyStatus,
}) => {
  const { t } = useTranslation();
  const [isCompanyActive, setIsCompanyActive] = useState(company.activated);

  const updateCompanyStatus = () => {
    const newStatus = !isCompanyActive;
    handleUpdateCompanyStatus(company.id, { isActivated: newStatus }).then(() =>
      setIsCompanyActive(newStatus)
    );
  };

  return (
    <CompanyBox key={company.id}>
      <CommitteCompanyTitle>
        <CommitteCompanyName>
          {`${company.name} - ${company.abbreviation}`}
        </CommitteCompanyName>
      </CommitteCompanyTitle>
      <div>
        <FormControlLabel
          control={
            <Tooltip title={isCompanyActive ? t("deactivate") : t("activate")}>
              <Switch
                checked={isCompanyActive}
                onChange={updateCompanyStatus}
                color="primary"
              />
            </Tooltip>
          }
          label={isCompanyActive ? t("active") : t("inactive")}
        />
        <CompanyActionButton onClick={() => handleUpdateCompany(company)}>
          <Edit />
        </CompanyActionButton>
      </div>
    </CompanyBox>
  );
};

export default CompaniesListItem;
